import { visibleClusterKeysFromNodes } from '../tagLayout';
import { fwd, ndc, ndc2, NODE_CORE_RADIUS, right, tagWorld } from './vectors';

export function collectVisibleClusterKeys(camera, meshByTaskId) {
  const nodes = [];
  if (!meshByTaskId || !camera) return visibleClusterKeysFromNodes(nodes);
  camera.getWorldDirection(fwd);
  right.crossVectors(fwd, camera.up);
  const haveRight = right.lengthSq() >= 1e-8;
  if (haveRight) right.normalize();
  meshByTaskId.forEach((mesh) => {
    const key = mesh.userData?.nodeMeta?.clusterKey;
    if (!key || key === '__none__') return;
    const ud = mesh.userData;
    if (!mesh.visible || ud.exiting || (ud.visT ?? 1) < 0.05) return;
    ndc.copy(mesh.position).project(camera);
    if (ndc.z < -1 || ndc.z > 1) return;
    let r = 0;
    if (haveRight) {
      const worldR = NODE_CORE_RADIUS * (ud.layoutScale > 0 ? ud.layoutScale : Math.max(mesh.scale.x, ud.nodeMeta?.size ?? 1));
      ndc2.copy(mesh.position).addScaledVector(right, worldR).project(camera);
      r = Math.hypot(ndc2.x - ndc.x, ndc2.y - ndc.y);
    }
    nodes.push({ key, x: ndc.x, y: ndc.y, z: ndc.z, r });
  });
  return visibleClusterKeysFromNodes(nodes);
}

export function collectNodeScreens(camera, meshByTaskId, out) {
  out.length = 0;
  if (!meshByTaskId) return out;
  camera.getWorldDirection(fwd);
  right.crossVectors(fwd, camera.up);
  if (right.lengthSq() < 1e-8) return out;
  right.normalize();
  meshByTaskId.forEach((mesh) => {
    const ud = mesh.userData;
    if (!mesh.visible || ud.exiting || (ud.visT ?? 1) < 0.05) return;
    const pos = mesh.position;
    ndc.copy(pos).project(camera);
    if (ndc.z < -1 || ndc.z > 1) return;
    const worldR = NODE_CORE_RADIUS * (ud.layoutScale > 0 ? ud.layoutScale : Math.max(mesh.scale.x, ud.nodeMeta?.size ?? 1));
    ndc2.copy(pos).addScaledVector(right, worldR).project(camera);
    out.push({
      x: ndc.x,
      y: ndc.y,
      r: Math.hypot(ndc2.x - ndc.x, ndc2.y - ndc.y),
      clusterKey: ud.nodeMeta?.clusterKey,
    });
  });
  return out;
}

export function collectWireScreens(camera, edgeLinesByKey, out) {
  out.length = 0;
  if (!edgeLinesByKey) return out;
  edgeLinesByKey.forEach((line) => {
    if (!line.visible || (line.material?.opacity ?? 0) < 0.04) return;
    const pos = line.userData.curvePositions;
    const n = line.userData.sampleCount || 0;
    if (!pos || n < 2) return;
    const step = Math.max(1, Math.ceil((n - 1) / 8));
    let px = 0;
    let py = 0;
    let have = false;
    for (let i = 0; i < n; i += step) {
      tagWorld.set(pos[i * 3], pos[i * 3 + 1], pos[i * 3 + 2]);
      ndc.copy(tagWorld).project(camera);
      if (have && ndc.z > -1 && ndc.z < 1) {
        out.push({ x1: px, y1: py, x2: ndc.x, y2: ndc.y });
      }
      px = ndc.x;
      py = ndc.y;
      have = ndc.z > -1 && ndc.z < 1;
    }
    if (step > 1 && (n - 1) % step !== 0) {
      tagWorld.set(pos[(n - 1) * 3], pos[(n - 1) * 3 + 1], pos[(n - 1) * 3 + 2]);
      ndc.copy(tagWorld).project(camera);
      if (have && ndc.z > -1 && ndc.z < 1) {
        out.push({ x1: px, y1: py, x2: ndc.x, y2: ndc.y });
      }
    }
  });
  return out;
}
